// CONSTANTS
import { ROUTE_DISCOVER_APP } from '@/constants/routes';

// UTILITY
import getLink from '@/utility/routes';
import { getS3ImageUrl } from '@/utility/content';

const defaultOGImg = getS3ImageUrl('/og-image/apps.png');

export default data => {
  const appData = data.app || {};
  const url = appData?.unique_slug
    ? getLink(ROUTE_DISCOVER_APP, { slug: appData?.unique_slug })
    : '';
  const image = appData.og_image_url
    ? getS3ImageUrl(`/og-image/apps/${appData.og_image_url}`)
    : defaultOGImg;

  return {
    '@type': 'BroadcastService',
    broadcastDisplayName: appData?.name,
    name: appData?.name,
    description: appData?.meta_description,
    inLanguage: 'English',
    url,
    logo: appData?.thumbnail,
    image,
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      price: appData.price,
      priceCurrency: 'USD',
      url,
    },
  };
};
